import styles from './GivewayHeader.module.css'

const GivewayHeader = () => {
    return (
        <div className={styles.leaderboardHeader}>
            <div className={styles.leaderboardHeader__content}>
                <div className={styles.leaderboardHeader__title}>
                    Giveway
                </div>
                <div className={styles.subtitle}>
                    Занимай места среди топ-игроков<br/>и получай награды!
                </div>
            </div>
        </div>
    )
}

export default GivewayHeader